const useExtractID = () => {
	// Ensure that document.body is not null
	const bodyClass = document.body?.className;

	if (bodyClass) {
		// Define a combined regular expression to match page-id, term, or postid class
		const combinedRegex = /(?:page-id|term|postid)-(\d+)/g;

		// Initialize variable to store the last found match
		let lastMatch = null;
		let match;

		// Use the regular expression to find all matches in the body class
		while ((match = combinedRegex.exec(bodyClass)) !== null) {
			// Update lastMatch with the current match
			lastMatch = parseInt(match[1], 10);
		}

		return lastMatch;
	}

	// Return null if document.body is null or className is not defined
	return null;
};

// Export the useExtractID function as the default export
export default useExtractID;
